<template>
  <div class="part part_about">
    <div class="title"> 
      <img src="../../static/other/line.png"/>
        <h2>应用简介</h2>
        <h2>APPLICATION INTRODUCTION</h2>
    </div>    
    <el-row>
      <el-col :xs="24" :sm="12" class="about_left">
        <div class="wrap">
          {{ intro[0].content }}
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" class="about_right">
        <img :src="aboutImg[0].img"/>
      </el-col>
    </el-row>
  </div> 

</template>
<script>
    export default {
        name: 'Intro',
        data () {
            return {
              intro: [
                        {
                            title: "应用简介",
                            content: "车迹忆是一家专注提高用户美好生活服务的平台。近几年来，客户服务体验差，服务质量粗糙，管理体系不健全等问题在行业屡见不鲜。公司的几大创始人，凭借在行业十年从业的心得体会，经验积累，并不断改进创新，立志通过十年经验和服务经验，建立一个更好更专业的服务公司，“诚信、有担当、公平正义”是勉学优品的企业价值观。"
                        }
                    ],
              aboutImg:[
                {
                  img: require('../../static/other/intro.jpg')
                }
              ]
            }
        }
    }
</script>

<style scoped>
  /* 公共 */
  .part{
    margin: 100px 0 200px 0;
  }
  .title{
    text-align: center;
    margin: 120px 0;
    color: #317bcb;
  }
  .about_left{
    padding: 0% 5% 5% 25%;
  }
  .about_left ul{
    list-style: none;
    padding-left: 0;
  }
  .about_left ul li{
    text-decoration: none;
    line-height: 2em;
  }
  .about_left li img{
    margin-right: 10px;
  }
  .about_right img{
    width: 60%;
  }
    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {
      .part{
        margin: 50px 0;
      }
      .title{
        margin: 0;
      }
      .about_left{
        padding: 5% 15% 5% 15%;
      }    
      .about_right img{
        width: 90%!important;
        margin-left: 5%;
      }
    }
</style>